import { createModel } from 'xstate/lib/model';

import { CompanyContextType } from 'common/hooks/useCompanyContext/types';
import { CompanyCreationLegalForm } from 'features/Bento/flows/signup/machine/model';
import baseEvents from 'features/Bento/libs/machines/config/baseEvents';

import { OnboardingCompanyQuery } from '../graphql/queries/onboardingCompany.gql';
import { OnboardingUserQuery } from '../graphql/queries/onboardingUser.gql';
import { ApplicationTypeContextType } from '../lib/applicationType';

export interface OnboardingModuleData {
  user: OnboardingUserQuery['viewer'];
  companyData?: OnboardingCompanyQuery['viewer'] &
    Pick<OnboardingCompanyQuery, 'shouldAskSanctionsDeclarationQuestions'>;
  applicationTypeContext: ApplicationTypeContextType;
  companyContext: CompanyContextType;
  createNewAccount: () => Promise<void>;
  isMobile: boolean;
}

export interface Context {
  companyLegalForm: CompanyCreationLegalForm | null;
  getModuleData: () => OnboardingModuleData;
}

const context = {
  companyLegalForm: null as CompanyCreationLegalForm | null,

  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
} as Context;

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,

      SAVE_PREV: (data: string) => ({ data }),
      SELECT_BENEFICIARY: () => ({}),
      SELECT_CAPITAL_DEPOSIT: () => ({}),
      SELECT_CAPITAL_DEPOSIT_MANDATEE: () => ({}),
      SELECT_COMPANY_CREATION: () => ({}),
      SELECT_PENDING_MANDATEE_APPLICATION: () => ({}),
      SELECT_SASU_CREATION: () => ({}),
      SELECT_SHINE_START: () => ({}),
      SELECT_STANDARD: () => ({}),
      SELECT_START_NEW_MANDATEE_APPLICATION: () => ({}),
      SUBMIT_COMPANY_CREATION_LEGAL_FORM: (data: CompanyCreationLegalForm) => ({
        data,
      }),
    },
  },
);

export default model;

export type Model = typeof model;
